/*
 *  Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.0.0
 */

import get from 'lodash/get';
import intersection from 'lodash/intersection';
import { SagaIterator } from 'redux-saga';
import { select } from 'redux-saga/effects';

import { AuthorityRoleEnum } from '../../../pages/PageAuth/constants/authConstants';
import { makeSelectAuthAuthorities } from '../../../pages/PageAuth/selectors/authSelectors';
import { IAuthority } from '../../../pages/PageAuth/types/authTypes';
import { Access } from '../constants/guard/accessGuardConstants';
import { AccessComponentKeyEnum } from '../constants/guard/guardConstants';

export function* checkGuardRoleSaga(componentKey: AccessComponentKeyEnum): SagaIterator {
    // user roles
    const authorities: IAuthority[] = yield select(makeSelectAuthAuthorities());
    // needed roles to current component
    const allowedRoles: AuthorityRoleEnum[] | undefined = get(Access[componentKey], 'role');
    return (
        allowedRoles === undefined ||
        intersection(
            allowedRoles,
            authorities.map((authority) => authority.authority),
        ).length > 0
    );
}
